// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__ygkVY","footer":"ModalError_footer__2BLy0"};